import script from "./plateChangeContentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./plateChangeContentModal.vue?vue&type=script&setup=true&lang=js"

import "./plateChangeContentModal.vue?vue&type=style&index=0&id=595513c7&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-595513c7"]])

export default __exports__